@if (fieldData().readonly) {
    <cipo-text-view [value]="control().value" [config]="fieldData()" />
} @else {
    <cipo-outline-field
        [label]="fieldData().label"
        [error]="control().touched && control().invalid"
        [required]="fieldData().required"
        bgColorClass="cipo-bg--white"
        [markChanged]="fieldData().markChanged && valueChanged()">
        <div class="cipo--height--full cipo--overflow-y--auto" [style.maxHeight]="maxHeight()" fxLayout="row wrap">
            @if (!fieldData().multiple) {
                <mat-radio-group
                    [disabled]="fieldData().disabled"
                    [name]="fieldData().label"
                    [value]="control().value"
                    (change)="radioChange($event)"
                    fxLayout="row wrap">
                    @for (item of deepFieldData.options(); track item.key) {
                        <mat-radio-button
                            [fxFlex.gt-sm]="fieldData().columns ? 100 / fieldData().columns : 100"
                            [fxFlex.lt-md]="100"
                            [value]="item.key"
                            [disabled]="item.isDisabled">
                            <p>{{ item.value | translate }}</p>
                        </mat-radio-button>
                    }
                </mat-radio-group>
            } @else {
                @for (item of deepFieldData.options(); track item.key) {
                    <mat-checkbox
                        [fxFlex.gt-sm]="fieldData().columns ? 100 / fieldData().columns : 100"
                        [fxFlex.lt-md]="100"
                        [checked]="isOptionSelected(item.key)"
                        [disabled]="fieldData().disabled || item.isDisabled"
                        (change)="checkboxChange($event, item.key)">
                        <p>{{ item.value | translate }}</p>
                    </mat-checkbox>
                }
            }
        </div>

        @if (fieldData().fieldDescription) {
            <mat-icon class="material-icons-outlined cipo--cursor--help"
                      [title]="fieldData().fieldDescription | translate">
                info
            </mat-icon>
        }
    </cipo-outline-field>

    @if (control().touched && control().invalid) {
        <p class="cipo-field-subscript cipo-text--warn-900">
            {{ control().hasError("custom") ? control().errors.custom : ("errors.required" | translate) }}
        </p>
    } @else if (fieldData().hint) {
        <p class="cipo-field-subscript">{{ fieldData().hint | translate }}</p>
    }
}
